import React from 'react';
import PropTypes from 'prop-types';
import { Container, Paragraph, BoldText, NonBoldText } from './styles/GuestFavMessaging.styles';

const GuestFavMessaging = ({ guestFavMessages }) => {
  return (
    <Container>
      <Paragraph>
        <BoldText>{guestFavMessages?.dontLoseFav}</BoldText>
        <NonBoldText>
          <div>{guestFavMessages?.loginOrCreate}</div>
          <div>{guestFavMessages?.wishlistAddStyle}</div>
        </NonBoldText>
      </Paragraph>
    </Container>
  );
};

GuestFavMessaging.propTypes = {
  guestFavMessages: PropTypes.shape({
    dontLoseFav: PropTypes.string,
    loginOrCreate: PropTypes.string,
    wishlistAddStyle: PropTypes.string,
  }),
};

GuestFavMessaging.defaultProps = {
  guestFavMessages: {
    dontLoseFav: `Don't lose your favorites!`,
    loginOrCreate: 'Log in or create an account to make ',
    wishlistAddStyle: 'wishlists, add styles and more.',
  },
};

export default GuestFavMessaging;
